import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header").addClass("head1");
$("#nav2").addClass("active");
var mySwiper = new Swiper ('.product-swiper .swiper', {
    loop: true, // 循环模式选项
    
    // 如果需要分页器
    pagination: {
      el: '.product-swiper .swiper-pagination',
      clickable: true,
    },
    
    // 如果需要前进后退按钮
    navigation: {
      nextEl: '.product-swiper .swiper-button-next',
      prevEl: '.product-swiper .swiper-button-prev',
    },
    
  })        
  $(".play").click(function () {
    let video = $(this).parent().find("video")[0];
    if (video.paused) { //如果已暂停则播放
        $(this).hide();
        video.play(); //播放控制
    } else { // 已播放点击则暂停
        $(this).show();
        video.pause(); //暂停控制
    }
})
var mySwiper = new Swiper ('.product-swiper1 .swiper', {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 40,
    // 如果需要分页器
    pagination: {
      el: '.product-swiper1 .swiper-pagination',
      clickable: true,
    },
    
    // 如果需要前进后退按钮
    navigation: {
      nextEl: '.product-swiper1 .swiper-button-next',
      prevEl: '.product-swiper1 .swiper-button-prev',
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerGroup: 2,
        slidesPerView: 2,
        spaceBetween: 10,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerGroup: 3,
            slidesPerView: 3,
            spaceBetween: 25,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerGroup: 4,
            slidesPerView: 4,
            spaceBetween: 40,
        }
    },
    
  })    